<template>
  <Item
    tag="router-link"
    :to="{ name: 'contract', params: { id: value.id } }"
    :type="value.typename.toLowerCase()"
    :title="`${$t('accept')} / ${$t('decline')}`"
  >
    <template #datetime>
      <div class="row middle">
        <FontAwesomeIcon :icon="['fal', 'calendar-exclamation']" style="margin-right: 0.5em" />
        <span>{{ value.expiresAt | Moment('DD. MMM [kl.] HH.mm') }}</span>
      </div>
    </template>
    <template #details>
      <div v-if="$route.name === 'dashboard'">
        <FontAwesomeIcon :icon="['fal', 'drafting-compass']" style="margin-right: 3px" />
        {{ value.project.name }}
      </div>
      <div>
        <FontAwesomeIcon :icon="['fal', 'house']" style="margin-right: 3px" />
        {{ value.reference.name }}
      </div>
    </template>
  </Item>
</template>

<script>
import Item from '@/components/ListItem'
import { Moment } from '@/filters'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  filters: {
    Moment,
  },
  components: {
    Item,
  },
}
</script>

<style lang="scss">
.list-item--bid {
  a {
    text-decoration: none;
  }
}
</style>
